module.exports = __webpack_public_path__ + "img/GGD配电柜2.5a35c240.jpg";